import { combineReducers } from 'redux';
import makeSelectedReducer from '../../../oldpantheon/redux/creators/reducers/makeSelectedReducer';

const selected = makeSelectedReducer({
  model: `category`,
  initialState: `life`,
});

export default combineReducers({ selected });
